import { theme as antdTheme, ThemeConfig } from 'antd';

const initializeAntdTheme: ThemeConfig = {
    // This brings back default styles
    algorithm: antdTheme.defaultAlgorithm,

    token: {
        borderRadius: 2
    },
    components: {
        Menu: {
            itemHoverBg: "rgb(230,247,255)",
            itemMarginInline: 0,
        },
        Dropdown: {
            controlItemBgHover: "rgb(230,247,255)",
            padding: 0,
            paddingXXS: 0
        },
        Typography: {
            titleMarginBottom: "0",
            titleMarginTop: "0"
        },
        Radio: {
            colorPrimary: '#1677ff',
            colorBorder: '#d9d9d9',
            colorBgContainer: '#fff',
        },
        Drawer: {
            paddingLG: 24,
            paddingMD: 16
        }
    }
}

export default initializeAntdTheme;